import { NodeViewContent, NodeViewWrapper } from "@knowt/editor/react";
import Select from "@/components/Select";
import { themeColors } from "@/utils/themeColors";
import { ChevronDown } from "lucide-react";
import { iconSizes } from "@/utils/iconProps";

const CodeBlockComponent = ({
    node: {
        attrs: { language: defaultLanguage },
    },
    updateAttributes,
    extension,
    editor,
}) => {
    const defaultOptions = [{ label: "auto", value: null }];

    const langOptions = extension.options.lowlight.listLanguages().map((lang: string) => {
        return { value: lang, label: lang };
    });

    const options = [...defaultOptions, ...langOptions];

    return (
        <NodeViewWrapper style={{ position: "relative" }}>
            <Select
                disabled={!editor.isEditable}
                options={options}
                btnSx={{
                    position: "absolute",
                    right: "0.5rem",
                    top: "0.5rem",
                    backgroundColor: themeColors.neutralWhite,
                    borderRadius: "2rem",
                    fontSize: "1.2rem",
                    height: "3rem",
                    userSelect: "none",
                }}
                menuSx={{ width: "fit-content", maxHeight: "32rem", "& > ul": { paddingLeft: 0 } }}
                transitionOrigin={{
                    anchorOrigin: { vertical: "center", horizontal: "center" },
                    transformOrigin: { vertical: "center", horizontal: "center" },
                }}
                selected={{ label: defaultLanguage, value: defaultLanguage }}
                onChange={({ label: lang }) => updateAttributes({ language: lang })}
                adornment={
                    editor.isEditable ? <ChevronDown size={iconSizes.SM} fill={"currentColor"} strokeWidth={0} /> : null
                }
                renderLabel={({ label }) => label || "auto"}
            />
            <pre>
                <NodeViewContent as="code" />
            </pre>
        </NodeViewWrapper>
    );
};

export default CodeBlockComponent;
